export default {
  intro: {
    first: 'is a',
    second: 'with heterogeneous',
    competenze: 'skills',
    third: 'that integrates',
    tecnologia: 'technology',
    design: 'design and web development',
    fourth: 'to support the growth of its',
    clienti: 'clients'
  },
  nav: {
    chi: {
      title: 'Who',
      desc: 'Un gruppo di collaboratori dalle competenze diverse e ben integrate.',
      slug: 'who',
      children: {
        competenze: {
          title: "Competenze",
          slug: "competenze"
        },
        metodo: {
          title: "Metodo",
          slug: "metodo"
        },
        persone: {
          title: "Persone",
          slug: "persone"
        }
      }
    },
    come: {
      title: 'How',
      desc: 'Il nostro modo di lavorare e i nostri principali settori operativi.',
      slug: 'how',
      children: {
        marketing: {
          title: "Marketing & Comunicazione",
          slug: "marketing"
        },
        design: {
          title: "Design & Sviluppo",
          slug: "design-sviluppo"
        },
        building: {
          title: "Building & Industrial Automation",
          slug: "building-industrial-automation"
        }
      }
    },
    cosa: {
      title: 'What',
      desc: 'Una selezione dei progetti che abbiamo realizzato per i nostri clienti.',
      slug: 'what',
      children: {
        portfolio: {
          title: "Portfolio",
          slug: "cosa"
        },
      }
    },
    contatti: {
      aperto: 'is currently open.',
      chiuso: 'is currently closed.',
      mail: 'You can contact us by sending an',
      whatsapp: 'or a message on',
      telefono: 'If you prefer you can',
      telefonare: 'call',
      o: 'or',
      venire: 'come and see us',
      persona: 'in person.'
    }
  },
  filters: {
    'show-case': 'Show Cases',
    research: 'Research',
    client: 'Clients'
  },
  message: {
    read: "Read"
  }
}
